import {API, Endpoints} from '@brg/api';
import {useCallback, useEffect, useState} from "react";

export interface LMSDesignerLiteModel {
    id?: string;
    accountId?: string;
    name?: string;
    fullName?: string;
    [key: string]: unknown;
}

export interface LMSModuleThemeLessonInfoModel {
    id: string;
    moduleProjectId?: string;
    start: string; // ISO date string
    end: string; // ISO date string
    groupIds: string[];
    themeId?: string;
    lessonLink: string;
    classType?: number;
    type?: number;
    title?: Array<{ lang: string; name: string }>;
    status?: number;
    studentsMaxLimit?: number | null;
    timeSlotPerRerson?: number | null;
    openingAppointmentIn?: number | null;
    teacherId?: string | null;
    isGuestTeacher?: boolean | null;
    consultationFormat?: number | string | null;
    signUpSheetIds?: Record<string, string> | null;
    signUpSheetModels?: Record<string, LMSDesignerLiteModel> | null;
    attendanceSheetIds?: Record<string, string> | null;
    attendanceSheetModels?: Record<string, LMSDesignerLiteModel> | null;
}

export interface LMSModuleCourseGroup {
    groupId: string;
    name: Array<{ lang: string; name: string }>;
}

export interface LMSModuleLessonsInfoModel {
    projectId: string;
    lessons: LMSModuleThemeLessonInfoModel[];
    courseStartDate: string | null; // ISO date string
    courseEndDate: string | null; // ISO date string
    courseGroups?: LMSModuleCourseGroup[];
}

export const useGetModuleLessons = (projectId?: string, groupIds?: string[], refreshKey?: number) => {
    const [resp, setResp] = useState<LMSModuleLessonsInfoModel | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [internalRefetchKey, setInternalRefetchKey] = useState(0);

    // Стабильная строка для зависимостей
    const groupIdsKey = groupIds ? groupIds.sort().join(',') : '';

    const refetch = useCallback(() => {
        setInternalRefetchKey((k) => k + 1);
    }, []);

    useEffect(() => {
        if (!projectId) {
            setIsLoading(false);
            return;
        }

        let isCancelled = false;

        setIsLoading(true);
        setError(false);
        
        const request = API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetModuleLessons')
            .get()
            .addQuery('projectId', projectId);

        request
            .send()
            .then((r) => r.json())
            .then((r) => {
                if (isCancelled) return;
                
                if (r?.status === 403) {
                    setIsLoading(false);
                    setError(true);
                    return;
                }
                
                const rawLessons = r?.lessons || [];

                // Преобразуем данные из API в нужный формат (сохраняем как есть, без преобразования в Date)
                const transformedData: LMSModuleLessonsInfoModel = {
                    projectId: r?.projectId || projectId || '',
                    lessons: rawLessons.map((lesson: any) => ({
                        id: lesson.id || `new_lesson`,
                        start: lesson.start || '',
                        end: lesson.end || '',
                        groupIds: lesson.groupIds || [],
                        themeId: lesson.themeId || lesson.ThemeId || lesson.themeLongreadId || '',
                        lessonLink: lesson.lessonLink || '',
                        moduleProjectId: lesson.moduleProjectId || '',
                        classType: lesson.classType,
                        type: lesson.type,
                        title: lesson.title,
                        status: lesson.status,
                        studentsMaxLimit: lesson.studentsMaxLimit ?? lesson.StudentsMaxLimit,
                        timeSlotPerRerson: lesson.timeSlotPerRerson ?? lesson.TimeSlotPerRerson,
                        openingAppointmentIn: lesson.openingAppointmentIn ?? lesson.OpeningAppointmentIn,
                        teacherId: lesson.teacherId ?? lesson.TeacherId,
                        isGuestTeacher: lesson.isGuestTeacher ?? lesson.IsGuestTeacher,
                        consultationFormat: lesson.consultationFormat ?? lesson.ConsultationFormat,
                        signUpSheetIds: lesson.signUpSheetIds ?? lesson.SignUpSheetIds,
                        signUpSheetModels: lesson.signUpSheetModels ?? lesson.SignUpSheetModels,
                        attendanceSheetIds: lesson.attendanceSheetIds ?? lesson.AttendanceSheetIds,
                        attendanceSheetModels: lesson.attendanceSheetModels ?? lesson.AttendanceSheetModels,
                    })),
                    courseStartDate: r?.courseStartDate || null,
                    courseEndDate: r?.courseEndDate || null,
                    courseGroups: r?.courseGroups || [],
                };
                
                setIsLoading(false);
                setResp(transformedData);
            })
            .catch((e) => {
                if (isCancelled) return;
                console.error('Error fetching module lessons:', e);
                setIsLoading(false);
                setError(true);
            });

        return () => {
            isCancelled = true;
        };
    }, [projectId, refreshKey, internalRefetchKey]);

    return { moduleLessons: resp, isLoading, error, refetch };
};

import {API, Endpoints} from '@brg/api';
import {useCallback, useEffect, useState} from "react";

export interface LMSDesignerLiteModel {
    id?: string;
    accountId?: string;
    name?: string;
    fullName?: string;
    [key: string]: unknown;
}

export interface LMSModuleThemeLessonInfoModel {
    id: string;
    moduleProjectId?: string;
    start: string; // ISO date string
    end: string; // ISO date string
    groupIds: string[];
    themeId?: string;
    lessonLink: string;
    classType?: number;
    type?: number;
    title?: Array<{ lang: string; name: string }>;
    status?: number;
    studentsMaxLimit?: number | null;
    timeSlotPerRerson?: number | null;
    openingAppointmentIn?: number | null;
    teacherId?: string | null;
    isGuestTeacher?: boolean | null;
    consultationFormat?: number | string | null;
    signUpSheetIds?: Record<string, string> | null;
    signUpSheetModels?: Record<string, LMSDesignerLiteModel> | null;
    attendanceSheetIds?: Record<string, string> | null;
    attendanceSheetModels?: Record<string, LMSDesignerLiteModel> | null;
}

export interface LMSModuleCourseGroup {
    groupId: string;
    name: Array<{ lang: string; name: string }>;
}

export interface LMSModuleLessonsInfoModel {
    projectId: string;
    lessons: LMSModuleThemeLessonInfoModel[];
    courseStartDate: string | null; // ISO date string
    courseEndDate: string | null; // ISO date string
    courseGroups?: LMSModuleCourseGroup[];
}

export const useGetModuleLessons = (projectId?: string, groupIds?: string[], refreshKey?: number) => {
    const [resp, setResp] = useState<LMSModuleLessonsInfoModel | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [internalRefetchKey, setInternalRefetchKey] = useState(0);

    // Стабильная строка для зависимостей
    const groupIdsKey = groupIds ? groupIds.sort().join(',') : '';

    const refetch = useCallback(() => {
        setInternalRefetchKey((k) => k + 1);
    }, []);

    useEffect(() => {
        if (!projectId) {
            setIsLoading(false);
            return;
        }

        let isCancelled = false;

        setIsLoading(true);
        setError(false);
        
        const request = API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetModuleLessons')
            .get()
            .addQuery('projectId', projectId);

        request
            .send()
            .then((r) => r.json())
            .then((r) => {
                if (isCancelled) return;
                
                if (r?.status === 403) {
                    setIsLoading(false);
                    setError(true);
                    return;
                }
                
                const rawLessons = r?.lessons || [];

                // Преобразуем данные из API в нужный формат (сохраняем как есть, без преобразования в Date)
                const transformedData: LMSModuleLessonsInfoModel = {
                    projectId: r?.projectId || projectId || '',
                    lessons: rawLessons.map((lesson: any) => ({
                        id: lesson.id || `new_lesson`,
                        start: lesson.start || '',
                        end: lesson.end || '',
                        groupIds: lesson.groupIds || [],
                        themeId: lesson.themeId || lesson.ThemeId || lesson.themeLongreadId || '',
                        lessonLink: lesson.lessonLink || '',
                        moduleProjectId: lesson.moduleProjectId || '',
                        classType: lesson.classType,
                        type: lesson.type,
                        title: lesson.title,
                        status: lesson.status,
                        studentsMaxLimit: lesson.studentsMaxLimit ?? lesson.StudentsMaxLimit,
                        timeSlotPerRerson: lesson.timeSlotPerRerson ?? lesson.TimeSlotPerRerson,
                        openingAppointmentIn: lesson.openingAppointmentIn ?? lesson.OpeningAppointmentIn,
                        teacherId: lesson.teacherId ?? lesson.TeacherId,
                        isGuestTeacher: lesson.isGuestTeacher ?? lesson.IsGuestTeacher,
                        consultationFormat: lesson.consultationFormat ?? lesson.ConsultationFormat,
                        signUpSheetIds: lesson.signUpSheetIds ?? lesson.SignUpSheetIds,
                        signUpSheetModels: lesson.signUpSheetModels ?? lesson.SignUpSheetModels,
                        attendanceSheetIds: lesson.attendanceSheetIds ?? lesson.AttendanceSheetIds,
                        attendanceSheetModels: lesson.attendanceSheetModels ?? lesson.AttendanceSheetModels,
                    })),
                    courseStartDate: r?.courseStartDate || null,
                    courseEndDate: r?.courseEndDate || null,
                    courseGroups: r?.courseGroups || [],
                };
                
                setIsLoading(false);
                setResp(transformedData);
            })
            .catch((e) => {
                if (isCancelled) return;
                console.error('Error fetching module lessons:', e);
                setIsLoading(false);
                setError(true);
            });

        return () => {
            isCancelled = true;
        };
    }, [projectId, refreshKey, internalRefetchKey]);

    return { moduleLessons: resp, isLoading, error, refetch };
};

